<template>
    <div class="about-area ptb-100" id="despre-noi">
        <div class="container-fluid px-0">
            <div class="row align-items-center gx-0">
                <!-- <div class="col-lg-12 col-md-12">
                    <div class="about-img">
                        <img src="../assets/images/about/about4.png" alt="image">
                        <div class="shape"><img src="../assets/images/about/about-shape1.png"></div>
                    </div>
                </div> -->

                <div class="col-12">
                    <div class="about-content">
                       <div class="container">
                            <div class="content" style="text-align: center;">
                                <span class="sub-title"><img src="../assets/images/star-icon.png" alt="image"> Despre noi</span>
                                <h2>{{ content.title }}</h2>
                                <p v-html="content.description"></p>
                            </div>
                        
                            <div class="row justify-content-center">
                                <div 
                                    v-for="(feature, index) in content.features" 
                                    :key="index" 
                                    class="col-lg-4 col-md-6 col-sm-6"
                                >
                                    <div class="single-services-box">
                                        <div class="icon">
                                            <i :class="feature.icon"></i>
                                        </div>
                                        <h3>{{ feature.title }}</h3>
                                        <p>{{ feature.text }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</template>

<script>

export default {
    name: 'ASDespreNoi',
    props: {
        content: {
            type: Object,
            required: true,
        }
    }
}
</script>

<style scoped>
@media (min-width: 992px) {
  .content p {
    text-align: left;
  }
}
</style>